import styled from 'styled-components';
import { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../utils/usageTracker';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFooter = styled.footer.withConfig({
  displayName: "PublicPageFooterMinimal__StyledFooter",
  componentId: "c7b3nf-0"
})(["margin-top:auto;background-color:", ";padding:40px 0;width:100%;color:", ";"], theme.colors.PANTERA, theme.colors.OLAF);
const FooterContent = styled.div.withConfig({
  displayName: "PublicPageFooterMinimal__FooterContent",
  componentId: "c7b3nf-1"
})(["text-align:center;margin:0 auto;max-width:", ";width:100%;font-size:16px;"], theme.sizes.PUBLIC_PAGE_WIDTH);
const CopyrightSection = styled.section.withConfig({
  displayName: "PublicPageFooterMinimal__CopyrightSection",
  componentId: "c7b3nf-2"
})(["margin-bottom:16px;"]);
const FooterLinks = styled.ul.withConfig({
  displayName: "PublicPageFooterMinimal__FooterLinks",
  componentId: "c7b3nf-3"
})(["list-style:none;padding:0;margin:0;li{display:inline-block;padding:0 12px;}a{color:", ";&:hover{color:", ";}}"], theme.colors.FLINT, theme.colors.CALYPSO_LIGHT);
const PublicPageFooterMinimal = () => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(StyledFooter, {
      children: /*#__PURE__*/_jsxs(FooterContent, {
        children: [/*#__PURE__*/_jsx(CopyrightSection, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.publicFooter.copyRight",
            options: {
              year: new Date().getFullYear().toString()
            }
          })
        }), /*#__PURE__*/_jsxs(FooterLinks, {
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              href: `https://legal.hubspot.com/legal-stuff?hubs_content=${encodeURIComponent(window.location.hostname + window.location.pathname)}&hubs_content-cta=Legal+Stuff`,
              onClick: () => {
                usageTracker.track('navInteraction', {
                  action: 'footer-legal-click'
                });
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.publicFooter.legal"
              })
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              href: `https://legal.hubspot.com/privacy-policy?hubs_content=${encodeURIComponent(window.location.hostname + window.location.pathname)}&hubs_content-cta=Privacy+Policy`,
              onClick: () => {
                usageTracker.track('navInteraction', {
                  action: 'footer-privacy-click'
                });
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.publicFooter.privacy"
              })
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("span", {
              className: "hs-footer-cookie-settings",
              hidden: true,
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                onClick: () => {
                  usageTracker.track('navInteraction', {
                    action: 'footer-cookies-click'
                  });
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.publicFooter.cookies"
                })
              })
            })
          })]
        })]
      })
    })
  });
};
export default PublicPageFooterMinimal;